import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber, FormattedRelative } from 'react-intl'
import Icon from "../../common/icon/icon.component.jsx"
import SideBar from '../../common/layout/sidebar.component.jsx'
import StandardList from '../../common/listing/list.component.jsx'
import LoadingSpinner from '../../common/spinner/loading.component.jsx'
import ImportContactsModal from "../../customer/modal/ImportContactsModal"
import Integrations from "../../integration/Integrations"
import ImportCsvModal from "./csvmodal.component.jsx"
import ImportProductsModal from "./importproductsmodal.component.jsx"
import {getImportListingHeaders, IMPORT_TYPE, PRODUCT_IMPORT_TYPE} from "../../utils/external"

class ImportListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            rows: [],
            headers: [],
            integrationKey: '',
            type: this.props.match.params.type,
            loading: false,
            modal: '',
        }
        this.startImport = this.startImport.bind(this)
        this.refreshSearch = this.refreshSearch.bind(this)
        this.startCsvImport = this.startCsvImport.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.onChangeSelect = this.onChangeSelect.bind(this)
    }


    componentDidMount() {
        const isProductImport = PRODUCT_IMPORT_TYPE.includes(this.state.type)
        const menu =  isProductImport ? 'product' : 'contact'
        SideBar.activateMenu(menu)
        this.refreshSearch()

        AppContext.getApiClient().get('/integrated-features').then(r => {
            const supportedImportIntegrations = r.data.filter(f => f.id.includes(menu + '-import'))
            if (supportedImportIntegrations.length > 0) {
                this.setState({
                    integrationKey: supportedImportIntegrations[0].attributes.configuration.attributes.integrationKey,
                })
            }
        })
    }

    startImport(event) {
        event.preventDefault()
        switch (this.state.type) {
            case IMPORT_TYPE.PRODUCTS:
            case IMPORT_TYPE.MATRIX_PRODUCTS:
                this.setState({
                    modal: <ImportProductsModal
                        integrationKey={this.state.integrationKey}
                        importAll={true}
                        onChangeIntegrationSelect={this.onChangeSelect}
                        onClose={this.handleCloseModal}
                        productType={this.state.type}
                    />
                })
                break
            default:
                this.setState({
                    modal: <ImportContactsModal
                        integrationKey={this.state.integrationKey}
                        onCloseCallback={this.handleCloseModal}
                    />
                })
        }
    }

    startCsvImport(event) {
        event.preventDefault()
        this.setState({
            modal: <ImportCsvModal
                type={this.state.type}
                onClose={this.handleCloseModal}
            />
        })
    }

    handleCloseModal() {
        this.setState({
            modal: '',
            loading: true,
        })
        this.refreshSearch()
    }

    refreshSearch(event) {
        event?.preventDefault()
        AppContext.getApiClient().get('/imports/' + this.state.type).then(r => {
            this.setState({
                headers: r.data.length > 0 ? getImportListingHeaders() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
            })
        })
    }

    onChangeSelect(value) {
        this.setState({
            integrationKey: value,
            importBtn: <button onClick={this.startImport} className="btn btn-primary ml-2">
                <Icon value={"download"} />
                <FormattedMessage
                    id="listing.product.import.start_import_btn"
                    defaultMessage="Start new import"
                />
            </button>,
        })
    }

    row(item) {
        return [
            Integrations.getIntegrationNameFromKey(item.attributes.integrationKey),
            item.attributes.status,
            <FormattedNumber value={item.attributes.numberOfItemsImported} />,
            <FormattedNumber value={item.attributes.duration} />,
            <FormattedRelative value={new Date(item.attributes.createdAt)} />,
        ]
    }

    canStartExternalImport() {
        return this.state.integrationKey && ![IMPORT_TYPE.SUPPLIERS].includes(this.state.type)
    }

    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        }
        return (
            <div>
                {this.state.modal}
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-6 text-align-right ">

                                <button onClick={this.refreshSearch} className="btn btn-outline-primary mr-2">
                                    <Icon value={"sync"} />
                                    <FormattedMessage
                                        id="listing.product.import.refresh_btn"
                                        defaultMessage="Refresh"
                                    />
                                </button>

                                <button onClick={this.startCsvImport} className="btn btn-primary">
                                    <Icon value={"file-excel"} />
                                    <FormattedMessage
                                        id="listing.product.import.csv_import_btn"
                                        defaultMessage="CSV import"
                                    />
                                </button>

                                {this.canStartExternalImport() &&
                                    <button onClick={this.startImport} className="btn btn-primary ml-2">
                                        <Icon value={"download"}/>
                                        <FormattedMessage
                                            id="listing.product.import.start_import_btn"
                                            defaultMessage="Start new import"
                                        />
                                    </button>
                                }

                            </div>
                        </div>
                    </div>
                </div>
                {list}
            </div>
        );
    }
}

export default ImportListing


// WEBPACK FOOTER //
// ./src/product/import/listing.component.jsx